export default __webpack_public_path__ + "static/media/006-bike.ce490369.svg";